import { render, staticRenderFns } from "./AdminFilters.vue?vue&type=template&id=88f081fe&scoped=true&"
import script from "./AdminFilters.vue?vue&type=script&lang=js&"
export * from "./AdminFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f081fe",
  null
  
)

export default component.exports